import { QRService } from '../services/qrService';
import { QRStyleOptions } from '../types';

const DEFAULT_STYLE_OPTIONS: QRStyleOptions = {
  size: 256,
  margin: 2,
  color: {
    dark: '#000000',
    light: '#FFFFFF'
  },
  errorCorrectionLevel: 'M',
  logo: {
    enabled: false,
    size: 40,
    borderRadius: 8,
    backgroundColor: '#FFFFFF'
  },
  style: {
    transparentBackground: false,
    dotStyle: 'square',
    gradientColors: {
      enabled: false,
      startColor: '#000000',
      endColor: '#333333',
      direction: 'diagonal'
    }
  }
};

export const migrateExistingQRCodes = async (): Promise<void> => {
  try {
    // Get all existing QR codes
    const qrCodes = await QRService.getAllQRCodes();
    
    let migratedCount = 0;
    
    for (const qrCode of qrCodes) {
      // Check if QR code doesn't have styleOptions or has empty styleOptions
      if (!qrCode.styleOptions || Object.keys(qrCode.styleOptions).length === 0) {
        try {
          await QRService.updateQRCode(qrCode.id, {
            styleOptions: DEFAULT_STYLE_OPTIONS
          });
          migratedCount++;
        } catch (error) {
          console.error(`❌ Failed to migrate QR code ${qrCode.id}:`, error);
        }
      }
    }

    if (migratedCount > 0) {
      console.info(`Migrated ${migratedCount} QR code${migratedCount === 1 ? '' : 's'} to the current style format.`);
    }
  } catch (error) {
    console.error('❌ Migration failed:', error);
    throw new Error('Failed to migrate existing QR codes');
  }
};

// Function to check if migration is needed
export const checkMigrationNeeded = async (): Promise<boolean> => {
  try {
    const qrCodes = await QRService.getAllQRCodes();
    
    // Check if any QR codes are missing styleOptions
    const needsMigration = qrCodes.some(qr => 
      !qr.styleOptions || Object.keys(qr.styleOptions).length === 0
    );
    
    return needsMigration;
  } catch (error) {
    console.error('Error checking migration status:', error);
    return false;
  }
};
